(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('statement-type', {
            parent: 'entity',
            url: '/statement-type',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.statementType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/statement-type/statement-types.html',
                    controller: 'StatementTypeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('statementType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('statement-type-detail', {
            parent: 'entity',
            url: '/statement-type/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.statementType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/statement-type/statement-type-detail.html',
                    controller: 'StatementTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('statementType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'StatementType', function($stateParams, StatementType) {
                    return StatementType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'statement-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('statement-type-detail.edit', {
            parent: 'statement-type-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/statement-type/statement-type-dialog.html',
                    controller: 'StatementTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['StatementType', function(StatementType) {
                            return StatementType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('statement-type.new', {
            parent: 'statement-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/statement-type/statement-type-dialog.html',
                    controller: 'StatementTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                type: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('statement-type', null, { reload: 'statement-type' });
                }, function() {
                    $state.go('statement-type');
                });
            }]
        })
        .state('statement-type.edit', {
            parent: 'statement-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/statement-type/statement-type-dialog.html',
                    controller: 'StatementTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['StatementType', function(StatementType) {
                            return StatementType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('statement-type', null, { reload: 'statement-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('statement-type.delete', {
            parent: 'statement-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/statement-type/statement-type-delete-dialog.html',
                    controller: 'StatementTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['StatementType', function(StatementType) {
                            return StatementType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('statement-type', null, { reload: 'statement-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
